export default __webpack_public_path__ + "static/carousel1-46f3c86d10908e27abd98e102fc2be31.png";